module.exports = __webpack_public_path__ + "static/media/pic.45b0b605.jpg";